import DepartureSeatsContainer from './DepartureSeatsContainer';

export default DepartureSeatsContainer;
